module.exports = __webpack_public_path__ + "static/media/ristorante.ac0bda42.svg";